import React, { useEffect, useRef, useState } from "react";
import data from "../../json/Sample/Sample.json";
import { useParams } from "react-router-dom";
import Modal from "../Modal";
import { ReactComponent as Icon } from "../../Icons/whitearrow.svg";

const Sampleimg = () => {
  const { category } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const modalref = useRef();

  const Image = data.Images[category];

  const toggleModal = (index) => {
    setShowModal(!showModal);
    setCurrentImage(index);
  };


  const toggleClose = () => {
    setShowModal(!showModal);
  }
  const handlePrev = () => {
      if(currentImage>0){
        setCurrentImage(prev=>prev-1)
      }
  }
  const handleNext = () => {
     if(currentImage<Image.length-1){
      setCurrentImage(prev=>prev+1)
     }
  }
  

  useEffect(() => {
    const handleClick = (e) => {
      if (modalref.current && !modalref.current.contains(e.target)) {
        setShowModal(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  });

  return (
    <div className="w-full">
      <div className={`w-full grid gap-4 sm:gap-5 lg:gap-6 justify-center items-center ${category == "Composition" ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-4" : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"}`}>
        {Image.map((img, i) => (
          <button
            onClick={() => toggleModal(i)}
            key={i}
            className={`w-full mx-auto p-4 shadow-products h-full`}
          >
            <img className="w-full border border-journyborder h-full object-contain" src={process.env.PUBLIC_URL + img} />
          </button>
        ))}
      </div>

      <Modal modalref={modalref} show={showModal} onClose={toggleClose} sample={true}>
        <div className={`flex items-center gap-x-5 min-w-[40vw]  md:gap-x-10 justify-center ${category=="Composition"?"h-[80vh]":"  max-h-[80vh]"}`}>
          <button
            onClick={handlePrev}
            className="hidden lg:flex h-[45px] min-w-[45px] rounded-full bg-[#808087] flex justify-center items-center"
          >
            <Icon className="text-white arrowicon rotate-180" />
          </button>
          <button
            className={`w-full mx-auto p-4 shadow-products min-h-[30vh] h-full bg-white`}
          >
             <img
            src={process.env.PUBLIC_URL + Image[currentImage]}
            alt="sample_img"
            className=" w-full  min-h-[250px] h-full  md:max-w-[700px] lg:max-w-[800px] border border-journyborder h-full object-contain"
          />
          </button>
         
          <button
            onClick={handleNext}
            className="hidden lg:flex h-[45px] min-w-[45px] rounded-full bg-[#808087] flex justify-center items-center"
          >
            <Icon className="text-white arrowicon" />
          </button>
        </div>
        {/* MARK:MobileView */}
        <div className="flex lg:hidden justify-center items-center  gap-8 text-white mt-10">

          <button
            onClick={handlePrev}
            className=" flex h-[45px] w-[45px] rounded-full bg-[#808087] flex justify-center items-center"
          >
            <Icon className="text-white arrowicon rotate-180" />
          </button>
          <button
            onClick={handleNext}
            className=" flex h-[45px] w-[45px] rounded-full bg-[#808087] flex justify-center items-center"
          >
            <Icon className="text-white arrowicon" />
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Sampleimg;
